module.exports = __webpack_public_path__ + "static/media/home-news-img.74b03537.jpg";